module.exports = __webpack_public_path__ + "media/images/Google-plus-94c7c90a0d651dff296739742a421923.png";